var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter" }, [
    _c("div", { staticClass: "section section--filter" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "form",
            {
              staticClass:
                "form form--filter form--filter-vehicles large-width",
              attrs: { action: "#" },
              on: { submit: _vm.formSubmitHandler }
            },
            [
              _vm.isContentReady
                ? _c("div", [
                    _c("div", { staticClass: "filters" }, [
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedBrand" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.brand))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedBrand,
                                        expression: "selectedBrand"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark":
                                          _vm.selectedBrand !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedBrand",
                                      id: "selectedBrand"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedBrand = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.brands, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.id } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.brands && _vm.brands.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedBrand !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.brands,
                                        id: "selectedBrand",
                                        label: "name",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "id"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.name))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2705703343
                                      ),
                                      model: {
                                        value: _vm.selectedBrandObject,
                                        callback: function($$v) {
                                          _vm.selectedBrandObject = $$v
                                        },
                                        expression: "selectedBrandObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedModel" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.model))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedModel,
                                        expression: "selectedModel"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark":
                                          _vm.selectedModel !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedModel",
                                      id: "selectedModel"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedModel = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.availableModels, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.id } },
                                      [_vm._v(_vm._s(item.model))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.availableModels &&
                                _vm.availableModels.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedModel !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.availableModels,
                                        id: "selectedModel",
                                        label: "model",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "model"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.model))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1114889159
                                      ),
                                      model: {
                                        value: _vm.selectedModelObject,
                                        callback: function($$v) {
                                          _vm.selectedModelObject = $$v
                                        },
                                        expression: "selectedModelObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedCondition" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.lexicon.condition
                                    ? _vm.lexicon.condition
                                    : "Fahrzeugzustand"
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedCondition,
                                        expression: "selectedCondition"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark":
                                          _vm.selectedCondition !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedCondition",
                                      id: "selectedCondition"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedCondition = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.condition, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.id } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.condition && _vm.condition.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedCondition !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.condition,
                                        id: "selectedCondition",
                                        label: "name",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "id"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.name))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2705703343
                                      ),
                                      model: {
                                        value: _vm.selectedConditionObject,
                                        callback: function($$v) {
                                          _vm.selectedConditionObject = $$v
                                        },
                                        expression: "selectedConditionObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedYear" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.year_from))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedYear,
                                        expression: "selectedYear"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark": _vm.selectedYear !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedYear",
                                      id: "selectedYear"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedYear = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.years, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.value } },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.years && _vm.years.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedYear !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.years,
                                        id: "selectedYear",
                                        label: "label",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "value"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.label))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2069813454
                                      ),
                                      model: {
                                        value: _vm.selectedYearObject,
                                        callback: function($$v) {
                                          _vm.selectedYearObject = $$v
                                        },
                                        expression: "selectedYearObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--select" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "label label--select",
                              attrs: { for: "selectedType" }
                            },
                            [_vm._v(_vm._s(_vm.lexicon.vehicle_type))]
                          ),
                          _vm._v(" "),
                          _vm.isMobileAndTouch
                            ? [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedType,
                                        expression: "selectedType"
                                      }
                                    ],
                                    staticClass: "select",
                                    class: [
                                      {
                                        "select--dark": _vm.selectedType !== "*"
                                      }
                                    ],
                                    attrs: {
                                      name: "selectedType",
                                      id: "selectedType"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.selectedType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  _vm._l(_vm.types, function(item) {
                                    return _c(
                                      "option",
                                      { domProps: { value: item.id } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _vm.types && _vm.types.length > 0
                                  ? _c("multiselect", {
                                      staticClass:
                                        "multiselect--small multiselect--regular",
                                      class: [
                                        {
                                          "select--dark":
                                            _vm.selectedType !== "*"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.types,
                                        id: "selectedType",
                                        label: "name",
                                        placeholder: _vm.lexicon.all,
                                        "track-by": "id"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function(ref) {
                                              var option = ref.option
                                              return [
                                                _vm._v(_vm._s(option.name))
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2705703343
                                      ),
                                      model: {
                                        value: _vm.selectedTypeObject,
                                        callback: function($$v) {
                                          _vm.selectedTypeObject = $$v
                                        },
                                        expression: "selectedTypeObject"
                                      }
                                    })
                                  : _vm._e()
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "field-group field-group--range" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "label label--select",
                            attrs: { for: "priceInput" }
                          },
                          [_vm._v(_vm._s(_vm.lexicon.price))]
                        ),
                        _vm._v(" "),
                        _c("vue-slider", {
                          attrs: {
                            min: _vm.minPrice,
                            max: _vm.maxPrice,
                            height: 11,
                            step: "100",
                            "tooltip-formatter": _vm.priceFormatter
                          },
                          model: {
                            value: _vm.selectedRangePrice,
                            callback: function($$v) {
                              _vm.selectedRangePrice = $$v
                            },
                            expression: "selectedRangePrice"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-range__min" }, [
                          _vm._v(_vm._s(_vm.convertToCurrency(_vm.minPrice)))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-range__max" }, [
                          _vm._v(_vm._s(_vm.convertToCurrency(_vm.maxPrice)))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "action action--underline action--reset",
                        on: { click: _vm.resetFilters }
                      },
                      [
                        _c("span", { staticClass: "action__text" }, [
                          _vm._v(_vm._s(_vm.lexicon.filter_reset))
                        ])
                      ]
                    )
                  ])
                : [
                    _c("content-loader", {
                      attrs: {
                        height: 219,
                        width: 1050,
                        speed: 2,
                        primaryColor: "#f3f3f3",
                        secondaryColor: "#ecebeb"
                      }
                    })
                  ]
            ],
            2
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section section--results section--background-tertiary" },
      [
        _c("div", { staticClass: "wrapper" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _vm.isContentReady
                ? [
                    _vm.selectionPaginated && _vm.selectionPaginated.length > 0
                      ? [
                          _c(
                            "div",
                            { staticClass: "section--results__header" },
                            [
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    (_vm.isOnlyFirstPageLoaded
                                      ? _vm.totalOnFirstPageLoaded
                                      : _vm.selection.length) +
                                      " " +
                                      _vm.lexicon.vehicles
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "field-group field-group--select field-group field-group--select-sort"
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "sort", hidden: "" } },
                                    [_vm._v(_vm._s(_vm.lexicon.sorting))]
                                  ),
                                  _vm._v(" "),
                                  _vm.isMobileAndTouch
                                    ? [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.sortByType,
                                                expression: "sortByType"
                                              }
                                            ],
                                            staticClass: "select select--sort",
                                            attrs: { id: "sort", name: "sort" },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.sortByType = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "*",
                                                  disabled: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.lexicon.sorting)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(_vm.sortOptions, function(
                                              option
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    disabled: option.isDisabled
                                                  },
                                                  domProps: {
                                                    value: option.value
                                                  }
                                                },
                                                [_vm._v(_vm._s(option.label))]
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _vm.sortOptions &&
                                        _vm.sortOptions.length > 0
                                          ? _c("multiselect", {
                                              staticClass:
                                                "multiselect--small multiselect--sort",
                                              attrs: {
                                                options: _vm.sortOptions,
                                                id: "sort",
                                                label: "label",
                                                placeholder:
                                                  _vm.lexicon.sorting,
                                                "track-by": "value"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "singleLabel",
                                                    fn: function(ref) {
                                                      var option = ref.option
                                                      return [
                                                        _vm._v(
                                                          _vm._s(option.label)
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                2069813454
                                              ),
                                              model: {
                                                value: _vm.sortByTypeObject,
                                                callback: function($$v) {
                                                  _vm.sortByTypeObject = $$v
                                                },
                                                expression: "sortByTypeObject"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row row--grid" },
                            [
                              _vm._l(_vm.selectionPaginated, function(item) {
                                return [
                                  _c("v-deal", {
                                    attrs: { item: item, lexicon: _vm.lexicon }
                                  })
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectionPaginated &&
                    _vm.selectionPaginated.length === 0
                      ? _c("div", { staticClass: "row row--grid" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col col-sm-12 col-md-12 offset-lg-2 col-lg-8"
                            },
                            [
                              _c("div", {
                                staticClass: "body",
                                domProps: {
                                  innerHTML: _vm._s(_vm.lexicon.no_result)
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selection.length > _vm.selectionPaginated.length
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "action__container action__container--center"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "action action--bordered",
                                  on: { click: _vm.showMore }
                                },
                                [
                                  _c("span", { staticClass: "action__text" }, [
                                    _vm._v(_vm._s(_vm.lexicon.show_more))
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "row row--grid" },
                      _vm._l(9, function(i) {
                        return _c("content-loader", {
                          key: i,
                          staticClass:
                            "col col-sm-12 col-md-12 col-lg-4 teaser--deals",
                          attrs: {
                            height: 560,
                            width: 500,
                            speed: 2,
                            primaryColor: "#b8b7b7",
                            secondaryColor: "#c2c2c2"
                          }
                        })
                      }),
                      1
                    )
                  ]
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }